import { LogService } from '../../../../shared/services/log.service';
import { Validator } from '../../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../../ctrl.name.extractor';

export class CTRL_CHIPS implements Validator {

    public static id = 'CTRL_CHIPS';
    private message = 'error.ctr_CHIPS';



        public LOG: LogService = new LogService(CTRL_CHIPS);

         validate(form: any, map) {

              // vérifier si la règle est applicable sur mon formulaire
                    const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_CHIPS.id + '_');

                    if (rgs.length > 0) {
                        for (var rg of rgs) {
                           const ctrl = form.controls[rg];
                           const autresRenseignementStepId = map.get(ctrl.value.rgCtrls.autresRenseignements);
                           const autresRenseignementsChampCtrl = form.controls[autresRenseignementStepId];

                           const chips: string[] = autresRenseignementsChampCtrl?.value || [];

                           if (Array.isArray(chips) && chips.length > 0) {

                               // Vérifier chaque chips
                               const invalid = chips.some(chip => chip?.trim().length < 5);

                              if (invalid) {
                                // placer le message d'erreur
                                form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                              }
                              else {
                                  form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                                }
                              }
                              else {
                                  form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                              }

                           }
                 
                        }
                    }

         }
    

